import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import './index.css'
import App from './App.tsx'

import { OpenAPI } from "@/api";

OpenAPI.BASE = import.meta.env.VITE_API_URL;

OpenAPI.TOKEN = async () => {
    const token = localStorage.getItem("token");
    // console.log("TOKEN CALLBACK:", token);
    return token ?? "";
};

// console.log("OpenAPI.BASE =", OpenAPI.BASE);

// console.log("OpenAPI.TOKEN =", OpenAPI.TOKEN);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={import.meta.env.VITE_BASENAME || "/"}>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
